import { render } from "./PlayerInfo.vue?vue&type=template&id=908eab40&scoped=true"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"

import "./PlayerInfo.vue?vue&type=style&index=0&id=908eab40&scoped=true&lang=scss"
import "./PlayerInfo.vue?vue&type=style&index=1&id=908eab40&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908eab40"]])

export default __exports__